import {BASE_URL} from "../../config/network";
import {resolveWhiteLabelSubsidiaryId} from "../../config/subsidiaryId";

const uploadUserDocumentAPI = async ({authToken, subsidiaryId, payload}) => {
    const requestSubsidiaryId = resolveWhiteLabelSubsidiaryId(subsidiaryId);
    const URL = `${BASE_URL}/${requestSubsidiaryId}/client/user/documents`;
    const METHOD = "POST";
    const HEADERS = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
    };

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS,
        body: JSON.stringify(payload),
    });

    if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
    }

    if (response.status === 204) {
        return {};
    }

    return await response.json();
};

export {uploadUserDocumentAPI};
